import * as React from 'react'
import {toLocaleDateString} from '@oc/utils'
import {useCustomerRouteContext} from './CustomerContext'
import {useDateTimezoneState} from './DatetimeTimezoneStateContext'

export function useToLocaleDateString(): (dateOrTimestampSeconds: number | Date, timezone?: string) => string {
    const datetimeTimezoneState = useDateTimezoneState()

    return React.useCallback(
        (date: number | Date, timezone?: string) =>
            toLocaleDateString(date, datetimeTimezoneState.customerTimezoneSelected ? timezone : undefined),
        [datetimeTimezoneState.customerTimezoneSelected]
    )
}

export function useToLocaleDateStringFromRoute(): (dateOrTimestampSeconds: number | Date) => string {
    const timezone = useEffectiveTimezone()

    return React.useCallback((date: number | Date) => toLocaleDateString(date, timezone), [timezone])
}

/**
 * Gets effective timezone calculated from user setting (if browser timezone or customer timezone should be used) and selected customer.
 * @returns String if customer timezone should be used, undefined otherwise (browser timezone should be used)
 */
export function useEffectiveTimezone(): string | undefined {
    const {customer} = useCustomerRouteContext()
    const datetimeTimezoneState = useDateTimezoneState()
    return React.useMemo(
        () => (datetimeTimezoneState.customerTimezoneSelected ? customer?.customerTimezone || undefined : undefined),
        [datetimeTimezoneState.customerTimezoneSelected, customer]
    )
}
